<div>
  Are you having problems validating your address?
  <a
    actionLink
    (click)="addressFactory.confirmAndSetGeneralDelivery(addressObject)"
    >Click here</a
  >.
</div>
